

























import { Component, Prop, Vue } from "vue-property-decorator";
import mhlogo from "../assets/mh-logo.svg";
import { Statement } from "../store/user";
import Getter from "../store/getters";

@Component
export default class TransactionSummary extends Vue {
  @Prop() statement!: Statement;
  private balance_fields = [
    {
      key: "plan_previous_balance",
      label: "Previous Balance",
      transform: this.format_dollars
    },
    {
      key: "total_amount_credits",
      label: "Payments and Other Credits",
      transform: this.format_dollars,
      negative: true
    },
    {
      key: "total_amount_debits",
      label: "Purchases and Adjustments",
      transform: this.format_dollars
    },
    {
      key: "ctd_billed_fees",
      label: "Fees Charged",
      transform: this.format_dollars
    },
    {
      key: "ctd_billed_interest",
      label: "Interest Charged",
      transform: this.format_dollars,
      class: "line-after"
    }
  ];
  private other_fields = [
    {
      key: "current_balance",
      label: "New Total Balance",
      transform: this.format_dollars,
      class: "balance-row"
    },
    {
      key: "statement_date",
      label: "Statement Date",
      transform: (i: any) => i
    },
    {
      key: "limit",
      label: "Total Credit Line",
      transform: this.format_dollars
    },
    {
      key: "available_credit",
      label: "Total Credit Available",
      transform: this.format_dollars
    }
  ];
  format_dollars(value: number, negative: boolean) {
    let val = (value / 1).toFixed(2);
    val = `$${val
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      .replace("-", "")}`;
    if (negative) val = "-" + val;
    return val;
  }
}
